import { createAction } from 'typesafe-actions';
import { ServiceAccount } from './serviceAccount.reducer';

export const updateServiceAccount = createAction(
  'UPDATE_SERVICE_ACCOUNT',
  (serviceAccount: ServiceAccount) => ({
    serviceAccount,
  }),
)();
